// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Belt_SortArray = require("rescript/lib/js/belt_SortArray.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");

function empty(param) {
  return {
          fields: [],
          contextFields: [],
          campaignUidOptions: []
        };
}

function targetKindToString(kind) {
  if (kind === "Column") {
    return "column";
  } else {
    return "more_details";
  }
}

function targetKindFromString(str) {
  if (str === "more_details") {
    return "MoreDetails";
  } else {
    return "Column";
  }
}

function decodeObject(json) {
  return Belt_Option.getWithDefault(Js_json.decodeObject(json), {});
}

function getString(obj, key, defaultValue) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(Js_dict.get(obj, key), Js_json.decodeString), defaultValue);
}

function getBool(obj, key, defaultValue) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(Js_dict.get(obj, key), Js_json.decodeBoolean), defaultValue);
}

function decodeStringArray(json) {
  return Belt_Array.keepMap(Belt_Option.getWithDefault(Js_json.decodeArray(json), []), Js_json.decodeString);
}

function decodeFieldOption(json) {
  var obj = decodeObject(json);
  var target = Belt_Option.flatMap(Js_dict.get(obj, "target"), Js_json.decodeObject);
  var targetKind = Belt_Option.flatMap(target, (function (t) {
          return Belt_Option.map(Belt_Option.flatMap(Js_dict.get(t, "kind"), Js_json.decodeString), targetKindFromString);
        }));
  var targetField = Belt_Option.flatMap(target, (function (t) {
          var name = Belt_Option.flatMap(Js_dict.get(t, "name"), Js_json.decodeString);
          var key = Belt_Option.flatMap(Js_dict.get(t, "key"), Js_json.decodeString);
          if (name !== undefined) {
            return name;
          } else if (key !== undefined) {
            return key;
          } else {
            return ;
          }
        }));
  return {
          key: getString(obj, "key", ""),
          label: getString(obj, "label", ""),
          path: getString(obj, "path", ""),
          targetKind: targetKind,
          targetField: targetField,
          writable: getBool(obj, "writable", false),
          dataType: getString(obj, "data_type", "TextType"),
          listOptions: Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(obj, "list_options"), decodeStringArray), []),
          valueInput: getString(obj, "value_input", "text"),
          valueOptions: Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(obj, "value_options"), decodeStringArray), [])
        };
}

function decodeCampaignUidOption(json) {
  var obj = decodeObject(json);
  return {
          value: getString(obj, "value", ""),
          label: getString(obj, "label", "")
        };
}

function decodeArray(json) {
  return Belt_Array.map(Belt_Option.getWithDefault(Js_json.decodeArray(json), []), decodeFieldOption);
}

function decode(json) {
  var obj = decodeObject(json);
  var group = function (key) {
    return Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(obj, key), decodeArray), []);
  };
  return {
          fields: group("fields"),
          contextFields: group("context_fields"),
          campaignUidOptions: Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(obj, "campaign_uid_options"), (function (arr) {
                      return Belt_Array.map(Belt_Option.getWithDefault(Js_json.decodeArray(arr), []), decodeCampaignUidOption);
                    })), [])
        };
}

function basePath(campaignId) {
  if (campaignId !== undefined) {
    return "/api/v1/campaigns/" + campaignId + "/import_enrichment_rules/field_options";
  } else {
    return "/api/v1/import_enrichment_rules/field_options";
  }
}

function $$fetch(campaignId, onSuccess, onFailure) {
  Js_promise.$$catch((function (param) {
          Curry._1(onFailure, undefined);
          return Promise.resolve();
        }), Js_promise.then_((function (options) {
              Curry._1(onSuccess, options);
              return Promise.resolve();
            }), Http$ReactHooksTemplate.fetchGetJSONDecode(basePath(campaignId), (function (param) {
                  return Json_decode.field("data", (function (param) {
                                return Json_decode.field("field_options", decode, param);
                              }), param);
                }))));
}

function findByPath(options, path) {
  var allFields = Belt_Array.concat(options.fields, options.contextFields);
  return Belt_Array.getBy(allFields, (function (field) {
                return field.path === path;
              }));
}

function findByTarget(options, targetKindStr, targetField) {
  var kind = targetKindFromString(targetKindStr);
  return Belt_Array.getBy(options.fields, (function (field) {
                var k = field.targetKind;
                var kindMatches = k !== undefined ? k === kind : kind === "Column";
                var name = field.targetField;
                var fieldMatches = name !== undefined ? name === targetField : false;
                if (kindMatches) {
                  return fieldMatches;
                } else {
                  return false;
                }
              }));
}

function readablePaths(options) {
  return Belt_Array.concat(options.fields, options.contextFields);
}

function writableTargets(options) {
  return Belt_Array.keep(options.fields, (function (field) {
                return field.writable;
              }));
}

function sortByLabel(fields) {
  return Belt_SortArray.stableSortBy(fields.slice(0), (function (a, b) {
                return $$String.compare(a.label.toLowerCase(), b.label.toLowerCase());
              }));
}

function flatReadableOptions(options) {
  return Belt_Array.concat(sortByLabel(options.fields), sortByLabel(options.contextFields));
}

function flatWritableOptions(options) {
  return sortByLabel(writableTargets(options));
}

function isReadablePath(options, path) {
  if (path !== "") {
    return Belt_Array.some(flatReadableOptions(options), (function (field) {
                  return field.path === path;
                }));
  } else {
    return false;
  }
}

function encodeTargetValue(field) {
  var k = field.targetKind;
  var kind = k !== undefined ? targetKindToString(k) : "column";
  var name = field.targetField;
  var fieldName = name !== undefined ? name : field.key;
  return kind + "|" + fieldName;
}

function isWritableTarget(options, targetKindStr, targetField) {
  if (targetField !== "") {
    return Belt_Array.some(sortByLabel(writableTargets(options)), (function (field) {
                  return encodeTargetValue(field) === targetKindStr + "|" + targetField;
                }));
  } else {
    return false;
  }
}

function campaignUidValues(options) {
  return Belt_List.fromArray(Belt_Array.map(options.campaignUidOptions, (function (opt) {
                    return opt.value;
                  })));
}

var sourceTypeOptions = {
  hd: "FeedFile",
  tl: {
    hd: "ApiKey",
    tl: {
      hd: "User",
      tl: /* [] */0
    }
  }
};

var pipelineOptions = {
  hd: "feed_import",
  tl: {
    hd: "survey_trigger",
    tl: /* [] */0
  }
};

exports.sourceTypeOptions = sourceTypeOptions;
exports.pipelineOptions = pipelineOptions;
exports.empty = empty;
exports.targetKindToString = targetKindToString;
exports.targetKindFromString = targetKindFromString;
exports.decodeObject = decodeObject;
exports.getString = getString;
exports.getBool = getBool;
exports.decodeStringArray = decodeStringArray;
exports.decodeFieldOption = decodeFieldOption;
exports.decodeCampaignUidOption = decodeCampaignUidOption;
exports.decodeArray = decodeArray;
exports.decode = decode;
exports.basePath = basePath;
exports.$$fetch = $$fetch;
exports.findByPath = findByPath;
exports.findByTarget = findByTarget;
exports.readablePaths = readablePaths;
exports.writableTargets = writableTargets;
exports.sortByLabel = sortByLabel;
exports.flatReadableOptions = flatReadableOptions;
exports.flatWritableOptions = flatWritableOptions;
exports.isReadablePath = isReadablePath;
exports.encodeTargetValue = encodeTargetValue;
exports.isWritableTarget = isWritableTarget;
exports.campaignUidValues = campaignUidValues;
/* Http-ReactHooksTemplate Not a pure module */
